import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import RovingTabIndexItem from './roving-tab-index-item';
export default forwardRef(function TreeGridItem(_ref, ref) {
  let {
    children,
    ...props
  } = _ref;
  return createElement(RovingTabIndexItem, _extends({
    ref: ref
  }, props), children);
});
//# sourceMappingURL=item.js.map